// extracted by mini-css-extract-plugin
export var container = "_5n-1";
export var editor = "_5n-2";
export var resizable = "_5n-3";
export var wrapper = "_5n-0";